module.exports = __webpack_public_path__ + "img/stable.28762336.svg";